import React, { useState, useEffect } from 'react';
import { processSteps } from '../data/mock';
import * as Icons from 'lucide-react';

const ProcessSection = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % processSteps.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="pt-20 pb-4 md:pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Simple 3-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From consultation to registration, we handle everything for you
          </p>
        </div>

        {/* Desktop View */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {processSteps.map((step, index) => {
            const Icon = Icons[step.icon];
            return (
              <div
                key={step.id}
                className={`relative p-8 rounded-2xl transition-all duration-500 cursor-pointer ${
                  activeStep === index
                    ? 'bg-gradient-to-br from-purple-50 to-purple-100/50 shadow-xl scale-105'
                    : 'bg-gray-50 hover:bg-gray-100'
                }`}
                onClick={() => setActiveStep(index)}
              >
                <div
                  className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 transition-all duration-500 ${
                    activeStep === index
                      ? 'bg-gradient-to-r from-purple-600 to-purple-800 shadow-lg'
                      : 'bg-white'
                  }`}
                >
                  <Icon
                    className={`h-8 w-8 ${
                      activeStep === index ? 'text-white' : 'text-purple-700'
                    }`}
                  />
                </div>
                <div
                  className={`absolute top-4 right-4 text-5xl font-bold ${
                    activeStep === index ? 'text-purple-200' : 'text-gray-200'
                  }`}
                >
                  {step.id}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>

        {/* Mobile Slider */}
        <div className="md:hidden">
          <div className="relative overflow-hidden">
            {processSteps.map((step, index) => {
              const Icon = Icons[step.icon];
              return (
                <div
                  key={step.id}
                  className={`transition-all duration-500 ${
                    activeStep === index ? 'block' : 'hidden'
                  }`}
                >
                  <div className="p-8 rounded-2xl bg-gradient-to-br from-purple-50 to-purple-100/50 shadow-xl">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-r from-purple-600 to-purple-800 flex items-center justify-center mb-6 shadow-lg">
                      <Icon className="h-8 w-8 text-white" />
                    </div>
                    <div className="absolute top-4 right-4 text-5xl font-bold text-purple-200">
                      {step.id}
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-6 space-x-2">
            {processSteps.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveStep(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  activeStep === index ? 'bg-purple-400 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
